var map = {
	"./Lazada.png": 5756,
	"./Lazada02.png": 10054,
	"./LazadaTrusteeship.png": 10220,
	"./Offline stores.png": 69706,
	"./Other.png": 10089,
	"./Shopee.png": 37681,
	"./Shopee02.png": 39507,
	"./TikTok.png": 60657,
	"./TikTok02.png": 51872,
	"./temu.png": 79696
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41820;